// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Kk-z","tupacHeader":"Lk-z","tupacHeader2":"Mk-z","tupacMenu":"Nk-z","tupacMenu2":"Ok-z","tupacMain":"Pk-z","tupacMain2":"Qk-z"};